import DownloadIcon from '@mui/icons-material/GetApp';
import { Avatar } from '@mui/material';
import React, { useRef } from 'react';
import { MessagingAttendee } from '../../../../../../interfaces/interfaces';
import { useSelector } from '../../../../../../reduxToolkit/typedRedux';
import { createDisplayLink } from '../../../../../../services/helper';

interface VcardProps {
  attendee: MessagingAttendee;
  attendeeDetails: { [key: string]: { value: string; type?: string } };
  isOwn?: boolean;
}

export const Vcard = (props: VcardProps) => {
  const { attendee, attendeeDetails, isOwn } = props;

  const user = useSelector(({ common }) => common.user);
  const isMobilePreview = useSelector(({ common }) => common.isMobilePreview);

  const anchorRef = useRef<HTMLAnchorElement>(null);

  function handleVcfDownload() {
    if (!attendeeDetails) return;
    const phoneNumber = Object.values(attendeeDetails).find((field) => field.type === 'phonenumber')?.value;
    const fileContent = `BEGIN:VCARD
VERSION:3.0
N:${attendeeDetails.name.value};;;
EMAIL;type=INTERNET;type=pref:${attendeeDetails.email.value}
${phoneNumber ? `TEL;type=CELL:${phoneNumber}` : ''}
END:VCARD`;
    generateFile(fileContent, 'vcf');
  }

  function handleTextDownload() {
    if (!attendeeDetails) return;
    const fileContent = `${Object.keys(attendeeDetails).map((field) => `${field}:${attendeeDetails[field].value}`)}`;
    generateFile(fileContent, 'txt');
  }

  function generateFile(fileContent: string, type: 'vcf' | 'txt') {
    const file = new Blob([fileContent], { type: 'text/plain;charset=utf-8' });
    if (!anchorRef.current) return;
    anchorRef.current.download = `${attendeeDetails.name.value.replace(' ', '-')}.${type}`;
    anchorRef.current.href = URL.createObjectURL(file);
    anchorRef.current.click();
  }

  return (
    <div className="m-1">
      <a hidden ref={anchorRef} />
      <div className={`flex w-full ${isMobilePreview ? '' : '@sm:w-72'} p-2 border rounded-xl`}>
        <Avatar style={{ width: '3.5rem', height: '3.5rem' }} src={createDisplayLink(isOwn ? user?.avatar?._id : attendee.avatar, false)}>
          {isOwn ? user?.name?.substr(0, 1) : attendee.name?.substr(0, 1)}
        </Avatar>
        <div className="flex flex-col pl-2 overflow-hidden break-words">
          {Object.keys(attendeeDetails).map((field) => (
            <>
              {field === 'name' ? (
                <span className={`font-bold ${isMobilePreview ? '' : '@sm:text-lg'} `}>{attendeeDetails[field].value}</span>
              ) : field === 'email' ? (
                <span className={`font-bold ${isMobilePreview ? '' : '@sm:text-base'} mb-2`}>{attendeeDetails[field].value}</span>
              ) : (
                <div>
                  <span className="font-bold">{field}:</span>
                  <br /> {attendeeDetails[field].value?.startsWith(',') ? attendeeDetails[field].value?.slice(1) : attendeeDetails[field].value}
                </div>
              )}
            </>
          ))}
        </div>
      </div>
      <div className="flex mt-1 text-slate-500 flex-row-reverse">
        <div className="cursor-pointer ml-4" onClick={() => handleTextDownload()}>
          <DownloadIcon />
          .txt
        </div>
        <div className="cursor-pointer" onClick={() => handleVcfDownload()}>
          <DownloadIcon />
          .vcf
        </div>
      </div>
    </div>
  );
};
